import { ContentCard } from 'apps/dashboard/shared/scripts/components';

import SummaryBody from './SummaryBody';
import SummaryFooter from './SummaryFooter';
import SummaryHeader from './SummaryHeader';
import SummaryPrice from './SummaryPrice';

const CheckoutSummary = () => {
  return (
    <ContentCard>
      <SummaryHeader />
      <SummaryPrice />
      <SummaryBody />
      <SummaryFooter />
    </ContentCard>
  );
};

CheckoutSummary.displayName = 'CheckoutSummary';

export default CheckoutSummary;
